import { Typography } from "@mui/material";
import { EllipsesStyle } from "../Types/IEllipsesStyle";
import { IKeyDriveFonts } from "../Types/IKeyDriveFonts";

export function KeyDriveBodySubtittle({
    color,
    needEllipses,
    text,
    needBold,
    opacityParams
}: IKeyDriveFonts) {
    return (
        <Typography
            variant="body2"
            fontFamily="SEGOE UI"
            fontSize="16px"
            lineHeight="27px"
            fontWeight={needBold ? 600 : 400}
            color={color}
            sx={needEllipses ? EllipsesStyle : opacityParams?.needOpacity ? {
                opacity: opacityParams.opacityLevel
            } : {}}
            textTransform="none"
        >
            { text }
        </Typography>
    )
}